(ns teamoesterreich.admin-mode.detail-filter.destination-filter
  (:require [teamoesterreich.admin-mode.data.rights :as d-rights]
            [clojure.string]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.util.helper :as h] ;;(h/event-value e)
            [teamoesterreich.admin-mode.static-data :as staticData]
            [teamoesterreich.admin-mode.component.org-selector :as org-selector]
            [teamoesterreich.util.log :as log]))



(defonce DST_LIST staticData/DST_LIST )
(defonce DEP_LIST staticData/DEP_LIST )




(defn wait-do [!waiting? !loaded? event-fn]
  (fn [e]
    (let [val (h/event-value e)]
      (js/console.log "wait or do" @!waiting?)
      (when @!waiting? (js/clearTimeout @!waiting?))
      (reset! !waiting?
              (js/setTimeout
                (fn []
                  (event-fn val)
                  (reset! !waiting? false)
                  (reset! !loaded? false))
                500)))))

(defn wait-do-select [!waiting? !loaded? event-fn]
  (fn [e]
    (let [val (h/event-value e)]
      (js/console.log "wait or do" val)
      (event-fn val)
      (reset! !waiting? false)
      (reset! !loaded? false))))



(defn destination-block [!filter !waiting? !loaded?]
  [mui/grid
   {:item true
    :xs 12
    :style {:marginBottom "7px"}
    }

   [mui/paper
    [mui/grid
     {:container true
      :direction "row"
      :alignItems "flex-start"
      :justify "flex-start"
      :spacing 1
      :style {:padding "5px"}
      }

     [mui/grid
      {:item true
       :xs 12
       }
      [mui/grid
       {:container true
        :direction "row"
        :alignItems "flex-start"
        :justify "flex-start"
        :spacing 1
        }

       [mui/grid
        {:item true
         :lg 5
         :md 6
         :sm 8
         :xs 12
         }
        [mui/text-field
         {:default-value (str (:filter-zip @!filter))
          :label       "Plz (Bsp: 1080,1190,1180)"
          :placeholder "suche..."
          ;:class       (:text-field classes)
          :onChange   (wait-do !waiting? !loaded? (fn [val] (swap! !filter assoc :filter-zip val)))
          :fullWidth true
          :multiline   false}]]

       [mui/grid
        {:item true
         :md 6
         :xs 12
         }
        [org-selector/get-selector !filter (fn [] (reset! !loaded? false)) (d-rights/get-rights-orgId-filter d-rights/USER_SEARCH)]
        ]


       ]]]]])